import { CurrentUserStore } from './CurrentUserStore';
import { GoalStore } from './GoalStore';
import { KaizenLabServiceStore } from './KaizenLabServiceStore';
import { OrganizationStore } from './OrganizationStore';
import { PortfolioReportStore } from './PortfolioReportStore';
import { UiState } from './UiState';

export { CurrentUserStore, GoalStore, KaizenLabServiceStore, OrganizationStore, PortfolioReportStore, UiState };

export interface IStore {
  currentUserStore: CurrentUserStore;
  goalStore: GoalStore;
  kaizenLabServiceStore: KaizenLabServiceStore;
  organizationStore: OrganizationStore;
  portfolioReportStore: PortfolioReportStore;
  uiState: UiState;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/domain/store/index.ts